import { BOSS_FINAL_DEMO_INSIGHTS } from './bossFinalDemoData.js';

/**
 * Regras de demonstração e replay da `BossFinalScene` (RN-BF-041, DP-BF-052).
 *
 * Funções puras para que a regra seja testável sem Phaser. A cena passa
 * `import.meta.env.DEV` como `modoDev`.
 */

/**
 * Lista recebida vence em qualquer modo. Sem lista, a demonstração só existe em
 * DEV; em produção a cena usa `[]` (encerramento sem destaques, RN-BF-013).
 */
export function resolverInsightsDaCena(data, modoDev) {
    if (Array.isArray(data?.insights)) return data.insights;
    return modoDev === true ? BOSS_FINAL_DEMO_INSIGHTS : [];
}

/** A tecla `R` (replay) só é registrada em DEV. */
export function deveRegistrarReplay(modoDev) {
    return modoDev === true;
}
